import { createGlobalStyle } from 'styled-components';

export const GlobalStyleOverride = createGlobalStyle`
    .header-is-open #onetrust-consent-sdk {
        display: none;
    }
    /** Salesforce Chat */
    .headerAnnouncement .announcement { display: none; }
`;
